import React from 'react';

export default function BackgroundImage(props) {
  const {image, className, ...others} = props;

  return (
    <div className={"react-parallax-bgimage " + (className ? className : "")} 
      style={{ backgroundImage: `url(${image})`}} {...others} />
  )
}